/// <reference path="../../../teva/datepicker/datepicker.ts" />
/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../common/modals/modals.ts" />

namespace OfficeGuy.Apps {
    export class TimeRecorder {
        static IgnoreManualEndTimeEvent: boolean;
        static UpdateManualEndTime(Property) {
            if (TimeRecorder.IgnoreManualEndTimeEvent == true)
                return;
            if (Property != null) {
                if (Property == 0)
                    Teva.DatePicker.InputChange($("#DurationMinutes"));
                else if (Property == 1)
                    Teva.DatePicker.InputChange($("#DurationHours"));
                else if (Property == 2)
                    Teva.DatePicker.InputChange($(".og-timerecorder-endtime"));
                else if (Property == 3)
                    Teva.DatePicker.InputChange($(".og-timerecorder-starttime"));
            }

            var Minutes = 0;
            var StartTime = <Date>Teva.DatePicker.GetDateFromString(<string>$(".og-timerecorder-starttime").val(), Teva.DatePickerMode.Time);
            if (StartTime == null)
                return;

            TimeRecorder.IgnoreManualEndTimeEvent = true;
            var EndTime = <Date>Teva.DatePicker.GetDateFromString(<string>$(".og-timerecorder-endtime").val(), Teva.DatePickerMode.Time);
            if (Property == null)
                Property = 3;
            if (Property == 2)
                EndTime = <Date>Teva.DatePicker.GetDateFromString(<string>$(".og-timerecorder-endtime").val(), Teva.DatePickerMode.Time);
            else if (Property == 3)
                StartTime = <Date>Teva.DatePicker.GetDateFromString(<string>$(".og-timerecorder-starttime").val(), Teva.DatePickerMode.Time);

            var SelectedDate = <string>$(".og-timerecorder-date").val();

            $(".og-timerecorder-starttime").val(Teva.DatePicker.GetTimeAsString(StartTime)).trigger("change");

            if (SelectedDate.length > 0) {
                $('#Data_StartDate, #StartDate').val(SelectedDate + ' ' + Teva.DatePicker.GetTimeAsString(StartTime) + ':00');
                if ($(".og-timerecorder-endtime").val() == "24:00") {
                    var DateValue = Teva.DatePicker.GetDateFromString(<string>$(".og-timerecorder-date").val(), Teva.DatePickerMode.Date);
                    DateValue.setDate(DateValue.getDate() + 1);
                    $('#Data_EndDate, #EndDate').val(Teva.DatePicker.GetDateAsString(DateValue) + ' 00:00:00');
                }
                else
                    $('#Data_EndDate, #EndDate').val(SelectedDate + ' ' + Teva.DatePicker.GetTimeAsString(EndTime) + ':00');

            }
            else {
                $('#Data_StartDate, #StartDate').val("");
                $('#Data_EndDate, #EndDate').val("");
            }

            TimeRecorder.IgnoreManualEndTimeEvent = false;
        }

        static RefreshTimes($Source) {
            if ($Source.data("times-skipevent") == "1")
                return;

            $Source.data("times-skipevent", "1");
            $Source.trigger("change.datepicker");
            $Source.data("times-skipevent", "");

            var StartTime = <string>$(".og-timerecorder-starttime:input").val();
            var EndTime = <string>$(".og-timerecorder-endtime:input").val();
            var Date = <string>$(".og-timerecorder-date").val();
            if (Date.length > 0 && StartTime.length > 0 && EndTime.length > 0) {
                $('#Data_StartDate, #StartDate').val(Date + ' ' + StartTime + ':00');
                if (EndTime == "24:00") {
                    var DateValue = Teva.DatePicker.GetDateFromString(<string>$(".og-timerecorder-date").val(), Teva.DatePickerMode.Date);
                    DateValue.setDate(DateValue.getDate() + 1);
                    $('#Data_EndDate, #EndDate').val(Teva.DatePicker.GetDateAsString(DateValue) + ' 00:00:00');
                }
                else
                    $('#Data_EndDate, #EndDate').val(Date + ' ' + EndTime + ':00');

            }
            else {
                $('#Data_StartDate, #StartDate').val("");
                $('#Data_EndDate, #EndDate').val("");
            }
        }

        static Report_ShowEmailModal() {
            Modals.ShowInputDialog({
                Title: "שליחת דוח בדוא\"ל",
                Message: "הזן את כתובת הדוא\"ל לשליחה",
                InputClass: "input-ShortText input-ShortText-EmailAddress",
                ConfirmText: "שליחה",
                ConfirmEvent: function (EmailAddress) {
                    $('#EmailAddress').val(EmailAddress);
                    $('#Action').val('Email').closest("form").trigger("submit");
                },
                DefaultValue: <string>$('#EmailAddress').val()
            });
        }
    }
}
